<p>room-detail works!</p>
